


export enum DeliveryStatus {
	none = 'None',
	dc = 'Dc',
	truck = 'Truck',
	delivered = 'Delivered'
}